import React from 'react';
import { Advertorial } from './components/Advertorial';
import { FacebookPixel } from './components/FacebookPixel';
export function App() {
  return <div className="w-full bg-white" data-id="element-0">
      <FacebookPixel data-id="element-1" />
      <Advertorial data-id="element-2" />
    </div>;
}